import { DETERMINAR_PAGINA_ATUAL_RESUMO_FINANCEIRO } from '../types';

export default function determinarPaginaAtualResumoFinanceiro(paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_RESUMO_FINANCEIRO,
    payload: paginaAtual
  };
}
